export const API_URL: string = (
  process.env.BUN_PUBLIC_API_URL || "https://api.s.sitechatagent.com"
).replace(/\/+$/, "");

export function getToken(): string | null {
  return localStorage.getItem("token");
}

export function setToken(token: string) {
  localStorage.setItem("token", token);
}

export function clearToken() {
  localStorage.removeItem("token");
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export async function apiFetch<T = unknown>(
  path: string,
  options: RequestInit = {},
): Promise<T> {
  const token = getToken();
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as Record<string, string>),
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    clearToken();
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  const data = await res.json();

  if (!res.ok) {
    throw new Error((data as { error?: string }).error || "Request failed");
  }

  return data as T;
}

export interface User {
  id: string;
  email: string;
  display_name: string;
  plan: string;
  theme: string;
  is_admin: boolean;
  created_at: string;
}
